<template>
  <b-container fluid>
    <b-row>
      <b-col lg="3">
        <h1>АТОМ {{ balance.location_id }}</h1>
        <b-form-datepicker v-model="date" class="mb-2"></b-form-datepicker>
        <h1>{{ balance.day | moment }}</h1>
        <b-card
          border-variant="primary"
          header="Баланс"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
          class="text-center m-3"
        >
          <h5 class="balance-header">Сума в касі</h5>
          <b-input-group class="balance-input" append="грн">
            <b-form-input
              style="font-weight: bold"
              trim
              readonly
              v-bind:value="balance.cash"
            ></b-form-input>
          </b-input-group>
          <h5 class="balance-header">Карти та послуги</h5>
          <b-input-group class="balance-input" append="грн">
            <b-form-input
              style="font-weight: bold"
              trim
              readonly
              v-bind:value="profit"
            ></b-form-input>
          </b-input-group>
          <h5 class="balance-header">Інші плюси</h5>
          <b-input-group class="balance-input" append="грн">
            <b-form-input
              trim
              readonly
              v-bind:value="otherIncomes"
            ></b-form-input>
          </b-input-group>
          <h5 class="balance-header">Готівка зранку</h5>
          <b-input-group class="balance-input" append="грн">
            <b-form-input
              trim
              readonly
              v-bind:value="balance.morning_cash"
            ></b-form-input>
          </b-input-group>
          <h5 class="balance-header">Мінуси</h5>
          <b-input-group class="balance-input" append="грн">
            <b-form-input
              style="font-weight: bold"
              trim
              readonly
              v-bind:value="balance.outcome"
            ></b-form-input>
          </b-input-group>
          <h5 class="balance-header">Оплата картою</h5>
          <b-input-group class="balance-input" append="грн">
            <b-form-input
              trim
              readonly
              v-bind:value="balance.card_credit"
            ></b-form-input>
          </b-input-group>
        </b-card>
      </b-col>
      <b-col>
        <b-tabs>
          <b-tab title="Плюси" active>
            <div class="income-block">
              <incomes
                v-bind:incomes="currentIncomes"
                v-bind:club_id="this.$cookie.get('club_id')"
                v-on:refresh-balance="getMoney()"
              />
            </div>
          </b-tab>
          <b-tab title="Минуси">
            <div class="outcome-block">
              <outcomes
                v-bind:outcomes="currentOutcomes"
                v-bind:club_id="this.$cookie.get('club_id')"
                v-on:refresh-balance="getMoney()"
              />
            </div>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </b-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Incomes from "@/components/Incomes";
import Outcomes from "@/components/Outcomes";
import { mapActions } from "vuex";
export default {
  name: "Balances",
  components: {
    Incomes,
    Outcomes,
  },
  props: {},
  data: function () {
    return {
      date: null,
      balance: [],
      incomes: [],
      outcomes: [],
      class: "",
      activErr: "",
      AlertText: "",
    };
  },
  computed: {
    currentIncomes: function () {
      return this.incomes;
    },
    currentOutcomes: function () {
      return this.outcomes;
    },
    profit: function () {
      let sum = 0;
      let profits = this.incomes.filter((income) => {
        return income.source === 1 || income.source === 2;
      });
      profits.forEach((income) => {
        sum += income.amount;
      });
      return sum;
    },
    otherIncomes: function () {
      let sum = 0;
      let otherStuff = this.incomes.filter((income) => {
        return (
          income.source === 3 || income.source === 4 || income.source === 5
        );
      });
      otherStuff.forEach((income) => {
        sum += income.amount;
      });
      return sum;
    },
  },
  watch: {
    date: function (value) {
      axios
        .get(`${process.env.VUE_APP_API}/money/day/?date=${value}`, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          this.balance = response.data.Day;
          this.incomes = response.data.Incomes.reverse();
          this.outcomes = response.data.Outcomes.reverse();
        })
        .catch(function (error) {
          if (error.response) {
            alert("Цього дня немає в базі:(");
          }
        });
    },
  },
  async mounted() {
    await this.getMoney();
  },
  methods: {
    ...mapActions(["logOutUser"]),
    async getMoney() {
      await axios
        .get(`${process.env.VUE_APP_API}/money/day/`, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          this.balance = response.data.Day;
          this.incomes = response.data.Incomes.reverse();
          this.outcomes = response.data.Outcomes;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.logOutUser();
          }
        });
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped>
.balance-header {
  width: 80%;
  margin: auto;
}
.balance-input {
  width: 80%;
  margin: 10px auto 10px auto;
}
</style>
